import CityPageTemplate from "../city-template/CityPageTemplate";
import { lynchburgVaConfig } from "./data";

export default function LynchburgVaPage() {
  return <CityPageTemplate config={lynchburgVaConfig} />;
}